import Form, { Header, Input, Label, Select } from "../Forms/SmartForm";
import GoogleRecaptcha from "react-google-invisible-recaptcha";
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Modal from "../Modal/Modal";
import countries from "../../../libs/data/countries.json";
import jobTitles from "../../../libs/data/jobTitles.json";

const PdfSubmission = ({ article = {} }) => {
    let siteKey = "";
    if (typeof localStorage !== "undefined") {
        siteKey = localStorage.getItem("recaptchaSiteKey");
    }

    const form = useRef();
    const reCaptchaRef = useRef();
    const [displayFormModal, setDisplayFormModal] = useState({
        display: false,
        error: false,
    });
    const [displayThankModal, setDisplayThankModal] = useState(false);
    const [jobTitle, setJobTitle] = useState("");
    const [siteConfig, setSiteConfig] = useState({siteName:"labmanager",
        siteFullName:"Lab Manager"});
    const [disable, setDisable] = useState(false);

    useEffect(() => {
        const isDDN = document.querySelector(".drugdiscoverynews");
        const isCLM = document.querySelector(".clinicallabmanager");
        if (isDDN) {
            setSiteConfig({siteName:"drugdiscoverynews",
                siteFullName:"Drug Discovery News"});
        }
        if (isCLM) {
            setSiteConfig({siteName:"clinicallab",
                siteFullName:"Today's Clinical Lab"});
        }
    },[displayFormModal, displayThankModal]);

    const buttonTimeOut = () => {
        document.getElementById("btnClick");
        const validationEmail = document.forms["form"]["email"].value;
        const validationCountry = document.forms["form"]["lmg_demo_country"].value;
        if(validationEmail && validationCountry != ""){
            setDisable(true);
        }
    };

    const onSubmit = async (recaptcha) => {
        const formValues = form.current.getValuesAsObject();

        setDisplayFormModal((prev) => ({
            ...prev,
            error: false,
        }));

        try {
            const response = await axios.post(`/pdfGenerator/${article.articleNo}`, {
                formValues,
                recaptcha,
            });

            if (!response.data.success) {
                throw result;
            }

            setDisplayFormModal((prev) => ({
                ...prev,
                display: false,
            }));
            setDisplayThankModal(true);
            setDisable(false);
        } catch (error) {
            if (!error.response) {
                error.response = {
                    data: {
                        errors: [error.message],
                    },
                };
            }

            const data = error.response.data;

            if (data.errors) {
                setDisplayFormModal((prev) => ({
                    ...prev,
                    error: data.errors.join("<br />"),
                }));
                if (data.fieldErrors) {
                    form.current.setAllErrors(data.fieldErrors);
                }
                if (data.fieldValues) {
                    form.current.setValues(data.fieldValues);
                }

                return;
            }

            setDisplayFormModal((prev) => ({
                ...prev,
                error: `${error.response.status}: ${error.response.text}`,
            }));
        }
    };

    const validateRecaptcha = (e) => {
        e.preventDefault();
        reCaptchaRef.current.execute();
    };


    const pdfSubmissionModal = () => {
        return (
            <Modal>
                <div className="pdf-submission-modal">
                    <div className="button-wrapper">
                        <button
                            type="button"
                            className="close-btn corner background-transparent no-border text-white float-right"
                            onClick={() =>
                                setDisplayFormModal((prev) => ({
                                    ...prev,
                                    display: false,
                                }))
                            }
                        >
                            Cancel X
                        </button>
                    </div>
                    <div className="pdf-submission-content m-0">
                        <Header className="p-v-1 p-h-2 m-b-0 text-center">
                            <p className="m-b-0 text-inverted">
                                Complete the form below and we will email you a
                                PDF version of
                            </p>
                            <p
                                className="text-inverted bold"
                                dangerouslySetInnerHTML={{
                                    __html: article.title,
                                }}
                            ></p>
                        </Header>
                        <Form
                            id="pdf-submission-form"
                            className="p-v-1 p-h-2"
                            action={"/pdfGenerator"}
                            onSubmit={validateRecaptcha}
                            contextRef={form}
                            defaults={{ country: "CA" }}
                            name="form"
                        >
                            {displayFormModal.error && (
                                <div className="alert italic">
                                    <p>{displayFormModal.error}</p>
                                </div>
                            )}
                            <div className="form-row two-items">
                                <div className="form-group">
                                    <Label input="firstname">First Name</Label>
                                    <Input
                                        type="text"
                                        name="firstname"
                                        label="First Name"
                                        className="form-control border-light-grey m-b-1"
                                    />
                                </div>
                                <div className="form-group">
                                    <Label input="lastname">Last Name</Label>
                                    <Input
                                        type="text"
                                        name="lastname"
                                        label="Last Name"
                                        className="form-control border-light-grey m-b-1"
                                    />
                                </div>
                            </div>
                            <Label input="email" required>
                                Email Address
                            </Label>
                            <Input
                                type="email"
                                name="email"
                                label="Email Address"
                                className="form-control border-light-grey m-b-1"
                                required
                            />
                            <Label input="lmg_demo_country" required>
                                Country
                            </Label>
                            <Select
                                name="lmg_demo_country"
                                className="m-b-1 border-light-grey"
                                label="Country"
                                required
                            >
                                <option hidden value="">
                                    Select
                                </option>
                                {countries.map(({ name, code }) => (
                                    <option key={code} value={code}>
                                        {name}
                                    </option>
                                ))}
                            </Select>
                            <div
                                className={
                                    "form-row" +
                                    (jobTitle == "Other" && " two-items")
                                }
                            >
                                {/** Only if user select "Other", we would then show Other text field for job title*/}
                                <div className="form-group">
                                    <Label input="demo_job_title">
                                        Job Title
                                    </Label>
                                    <Select
                                        name="demo_job_title"
                                        label="demo_job_title"
                                        className="m-b-1 border-light-grey"
                                        onChange={(event) =>
                                            setJobTitle(event.target.value)
                                        }
                                    >
                                        <option hidden value="">
                                            Select
                                        </option>
                                        {jobTitles[siteConfig.siteName].map(
                                            (jobTitle) => (
                                                <option
                                                    key={jobTitle}
                                                    value={jobTitle}
                                                >
                                                    {jobTitle}
                                                </option>
                                            )
                                        )}
                                    </Select>
                                </div>
                                {jobTitle == "Other" && (
                                    <div className="form-group">
                                        <Label input="demo_job_title_other">
                                            Other
                                        </Label>
                                        <Input
                                            type="text"
                                            name="demo_job_title_other"
                                            label="Other"
                                            className="form-control border-light-grey m-b-1"
                                        />
                                    </div>
                                )}
                            </div>
                            <Label input="explicit_consent_confirmed">
                                Would you like to receive news updates and
                                relevant promotional content from{" "}
                                <em>{siteConfig.siteFullName}</em>?
                            </Label>
                            <Select
                                name="explicit_consent_confirmed"
                                className="border-light-grey m-b-1"
                            >
                                <option hidden value="">
                                    Select
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Select>
                            <button
                                type="submit"
                                className="btn brandedButton compact"
                                data-attribute="send-pdf-version"
                                id="btnClick"
                                disabled={disable}
                                onClick={() => setTimeout(buttonTimeOut, 100)}
                            >
                                <i
                                    className="far fa-file-pdf"
                                    aria-hidden="true"
                                    data-attribute="send-pdf-version"
                                />
                                <span data-attribute="send-pdf-version">Send PDF Version</span>
                            </button>
                            <button
                                className="close-btn in-form no-border"
                                onClick={() =>
                                    setDisplayFormModal((prev) => ({
                                        ...prev,
                                        display: false,
                                    }))
                                }
                            >
                                Cancel
                            </button>
                            <GoogleRecaptcha
                                ref={reCaptchaRef}
                                sitekey={siteKey}
                                onResolved= {onSubmit}
                            />
                        </Form>
                        <div className="form-footer background-white text-center p-v-1 p-h-2">
                            <p className="m-t-0 m-b-1">
                                <em>{siteConfig.siteFullName}</em> needs the
                                contact information you provide to us to contact
                                you about our products and services. You may
                                unsubscribe from these communications at any
                                time.
                            </p>
                            <p className="m-0">
                                For information on how to unsubscribe, as well
                                as our privacy practices and commitment to
                                protecting your privacy, check out our{" "}
                                <a href="/privacy-policy">Privacy Policy</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    const thankYouModal = () => {
        return (
            <Modal>
                <div
                    className="pdf-submission-modal"
                    id="download-pdf-confirmation"
                >
                    <div className="pdf-submission-content m-0">
                        <button
                            className="close-btn corner background-transparent no-border text-white float-right"
                            onClick={() => setDisplayThankModal(false)}
                        >
                            Close X
                        </button>
                        <Header className="p-v-1 p-h-2 m-b-0 text-center">
                            <h1 className="text-inverted">Thank you!</h1>
                            <p className="text-inverted">
                                We have emailed you a PDF version of the article
                                you requested.
                            </p>
                            <button
                                className="btn brandedButton compact inverted"
                                onClick={() => setDisplayThankModal(false)}
                            >
                                Close X
                            </button>
                        </Header>
                        <div className="form-footer background-white text-center p-v-1 p-h-2">
                            <h1>Can't find the email?</h1>
                            <p>Please check your spam or junk folder.</p>
                            <p>
                                You can also add{" "}
                                <a className="email" href={`mailto:info@${siteConfig.siteName}.com`}>
                                    info@{siteConfig.siteName}.com
                                </a>{" "}
                                to your safe senders list to ensure that you
                                never miss a message from us.
                            </p>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    return (
        <div id="PdfSubmission">
            {displayFormModal.display && pdfSubmissionModal()}
            {displayThankModal && thankYouModal()}
            <button
                className="btn brandedButton compact"
                data-attribute="get-pdf-version"
                onClick={() =>
                    setDisplayFormModal((prev) => ({
                        ...prev,
                        display: true,
                    }))
                }
            >
                <i className="far fa-file-pdf" aria-hidden="true" data-attribute="get-pdf-version"/>PDF Version
            </button>
        </div>
    );
};

export default PdfSubmission;
